function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.77907 30.0902H7.94186L8.73256 24.9622L9.72093 24.765L8.96311 21.8917C8.82723 21.3765 8.36132 21.0176 7.82854 21.0176H4.89239C4.35961 21.0176 3.8937 21.3765 3.75782 21.8917L3 24.765L3.98837 24.9622L4.77907 30.0902Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.36053 19.8343V19.8343C5.26888 19.8343 4.38379 18.9954 4.38379 17.9606V17.9606C4.38379 16.9259 5.26888 16.0869 6.36053 16.0869V16.0869C7.45219 16.0869 8.33728 16.9259 8.33728 17.9606V17.9606C8.33728 18.9954 7.45219 19.8343 6.36053 19.8343Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1344 13.3252V13.3252C15.6607 13.3252 14.4658 12.1331 14.4658 10.6626V10.6626C14.4658 9.19219 15.6607 8 17.1344 8V8C18.6082 8 19.803 9.19219 19.803 10.6626V10.6626C19.803 12.1331 18.6082 13.3252 17.1344 13.3252Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7597 30.0245H15.3394L14.7694 24.3604L12.4893 23.794V17.958C12.4893 16.7068 13.5102 15.6924 14.7694 15.6924H19.3297C20.5889 15.6924 21.6099 16.7068 21.6099 17.958V23.794L19.3297 24.3604L18.7597 30.0245Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.817 9.78905H11.9973",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3615 12.3391C24.3615 13.1016 24.981 13.7197 25.7452 13.7197C26.5094 13.7197 27.1289 13.1016 27.1289 12.3391",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.7848 14.7061V14.7061C28.3111 14.7061 27.1162 13.5139 27.1162 12.0435V12.0435C27.1162 10.573 28.3111 9.38086 29.7848 9.38086V9.38086C31.2586 9.38086 32.4534 10.573 32.4534 12.0435V12.0435C32.4534 13.5139 31.2586 14.7061 29.7848 14.7061Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.3636 30.0248H27.9434L27.3734 25.4935H23.9531L26.5713 17.903C26.7087 17.4125 27.1579 17.0732 27.6698 17.0732H31.6372C32.1491 17.0732 32.5989 17.4125 32.7357 17.903L35.3539 25.4935H31.9337L31.3636 30.0248Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M32.466 12.3391C32.466 13.1016 33.0855 13.7197 33.8497 13.7197C34.6139 13.7197 35.2334 13.1016 35.2334 12.3391",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgChildren = function SvgChildren(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChildren, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/children.cb87ebef.svg";
export { ForwardRef as ReactComponent };